// extracted by mini-css-extract-plugin
export var cardIcon = "_58-4";
export var checkboxCard = "_58-0";
export var checkboxCardSelected = "_58-3";
export var disabled = "_58-1";
export var outerBorder = "_58-2";
export var spacerMedium = "_58-7";
export var spacerSmall = "_58-6";
export var spacerXsmall = "_58-5";